import $ from "jquery";
import AjaxRequest from "../modules/ajax-request";
import LoginButton from "../modules/login-button";

class VideoConsultas {
    constructor(divRender) {
        this._divRender = divRender;
        this._renderActionUrl = this._divRender.data("render-action");
        this.div = "";
        this.form = "";
        this.loadingElement = "";
        this.formAction = "";

        this.init();
        this.bindEvents();
    }
    init() {
        this.clearData();
        this.renderContent();
    }
    getData() {
        this.div = $('[data-id="video-consulta"]');
        this.form = $(this.div).find('form');
        this.formAction = $(this.form).data("action");
        this.loadingElement = $(this.div).find(".add-load-element");
    }
    clearData() {
        $(this.form).removeAttr("data-action");
    }
    renderContent() {
        var _this = this;
        var _render = this._divRender;
        if (_render.length > 0) {
            var _ajaxRequest = new AjaxRequest({
                successCallback: function (response) {
                    _render.html(response.renderContentHtml);
                    _this.getData();
                    _this.bindEvents();
                    $('[data-login-show]').each(function(){
                        new LoginButton(this);
                    });
                }
            });
            _ajaxRequest.makeCall(this._renderActionUrl);
        }
    }
    bindEvents() {
        var _this = this;
        $(this.div).on("submit", this.form, function (event) {
            _this.submitForm(event);
        });
    }
    submitForm(event) {
        event.preventDefault();

        var _this = this;
        var _loadingElement = this.loadingElement;

        var _ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                _loadingElement.removeClass("loading");
                $(_this.form).replaceWith($(response));
                _this.form = $(_this.div).find('form');
                $(_this.form).removeAttr("data-action");
                if (typeof grecaptcha !== 'undefined' && $('.g-recaptcha').length > 0) {
                    if ($.trim($('.g-recaptcha').html()) === '') {
                        grecaptcha.render($('.g-recaptcha').get(0), { sitekey: $('.g-recaptcha').data('sitekey') });
                    } else {
                        grecaptcha.reset();
                    }
                }

            },
        });

        _loadingElement.addClass("loading");

        _ajaxRequest.makeCall(this.formAction, $(this.form).serialize());
    }
}

export default VideoConsultas;